import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { fetchServicedeskPortalAction } from '../state/actions.tsx';
import { getServicedeskPortalId } from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import ServicedeskPortalProvider, { type Props } from './view.tsx';

type OwnProps = Omit<Props, 'portalId' | 'onFetchServicedeskPortal'>;

const mapStateToProps = (state: State) => ({
	portalId: getServicedeskPortalId(state),
});

const mapDispatchToProps = {
	onFetchServicedeskPortal: fetchServicedeskPortalAction,
};

export default connect<State, typeof mapDispatchToProps, OwnProps>(
	// @ts-expect-error - TS2769 - Type 'unknown' is not assignable to type 'State'.
	mapStateToProps,
	mapDispatchToProps,
)(ServicedeskPortalProvider);
